export let RecordSelector = {
    recordType: 'unset', // collector, taxa, etc...

    init: function(recordtype, selectedStartCount) {
        RecordSelector.recordType = recordtype;

        $(document).ready(function() {
            $('.recordselector').change(function(e) {
                let record_id = e.target.id.match(/select_record_(\d+)/)[1];

                if ($(e.target).prop('checked')) {
                    RecordSelector.selectRecord(record_id);
                } else {
                    RecordSelector.unselectRecord(record_id);
                }
            });

            $('#selectAllButton').click(function(e) {
                RecordSelector.toggleSelectAll();
            });

            $('#clearSelectionButton').click(function(e) {
                RecordSelector.clearSelected();
            });

            $('#mergeButton').click(function(e) {
                window.location = '/merge_records/' + RecordSelector.recordType;
            });

            RecordSelector.updateSelectionStatus(selectedStartCount);
        });
    },

    selectRecord: function (id) {
        $.post('/record_select',
            {
                'recordtype': RecordSelector.recordType,
                'id': id
            },
            function(data) {
                RecordSelector.updateSelectionStatus(data.count);
            }
        );
    },

    unselectRecord: function(id) {
        $.post('/record_unselect',
            {
                'recordtype': RecordSelector.recordType,
                'id': id
            },
            function(data) {
                RecordSelector.updateSelectionStatus(data.count);
            }
        );
    },

    toggleSelectAll: function() {
        let ids = [];
        // are all records on the current page selected?
        if ($('.recordselector:checked').length < $('.recordselector').length ) {
            // select any that are not already checked
            $('.recordselector:not(:checked)').each(function (index, elem) {
                let record_id = elem.id.match(/select_record_(\d+)/)[1];
                ids.push(record_id);
            });
            if (ids.length > 0)
                RecordSelector.selectMultiple(ids);
        } else {
            // if all records are already selected,
            // unselect everything on the current page
            $('.recordselector:checked').each(function (index, elem) {
                let record_id = elem.id.match(/select_record_(\d+)/)[1];
                ids.push(record_id);
            });
            if (ids.length > 0)
                RecordSelector.unSelectMultiple(ids);
        }
    },

    selectMultiple: function(recordIds) {
        $.post('/record_select_multiple',
            {
                'recordtype': RecordSelector.recordType,
                'ids': recordIds
            },
            function(data) {
                recordIds.forEach(function(id) {
                    $('#select_record_'+id).prop('checked', true);
                })
                RecordSelector.updateSelectionStatus(data.count);
            }
        );
    },

    unSelectMultiple: function(recordIds) {
        $.post('/record_unselect_multiple',
            {
                'recordtype': RecordSelector.recordType,
                'ids': recordIds
            },
            function(data) {
                recordIds.forEach(function(id) {
                    $('#select_record_'+id).prop('checked', false);
                })
                RecordSelector.updateSelectionStatus(data.count);
            }
        );
    },

    clearSelected: function() {
        $.post('/record_select_clear',
            {
                'recordtype': RecordSelector.recordType
            },
            function(data) {
                RecordSelector.updateSelectionStatus(0);
                $('.recordselector').prop('checked', false);
            }
        );
    },

    updateSelectionStatus: function(count) {
        if (count > 0) {
            $('#selectionStatus').html(count + ' records selected');
            $('#selectionBox').css('visibility', 'visible');
        } else {
            $('#selectionBox').css('visibility', 'hidden');
        }
    }
};
